import takoColors from './colors';

export const theme = {
    colors: takoColors,
};
